import axios from 'axios';

const requester = axios.create({
  baseURL: process.env.REACT_APP_NEXT_PUBLIC_BASE_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

requester.interceptors.request.use((config) => {
  if (!config.baseURL) {
    return Promise.reject(new Error('Chưa cấu hình địa chỉ API'));
  }

  if (config.skipAuth) {
    delete config.headers.Authorization;
    return config;
  }

  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }

  return config;
});

requester.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_type_key');
      removeAxiosToken();

      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export function setAxiosToken(accessToken: string) {
  requester.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
}

export function removeAxiosToken() {
  delete requester.defaults.headers.common.Authorization;
}

export default requester;